/**
 * Qui GÈRE les parcours (créer, modifier, instancier un modèle) — liste UNIQUE, lue par le serveur
 * (`src/api/certification-paths.ts`, `src/api/path-templates.ts`) ET par l'écran
 * (`CertificationPathsPage`). Pure : importable côté client.
 *
 * CSL retiré (décision de Valérie du 30/09/2026) : fermé tant que ses droits ne sont pas arbitrés —
 * il listait et instanciait les modèles de parcours alors que l'écran ne le lui proposait pas.
 */
export const PATH_MANAGE_PROFILES = ["ADM", "COO", "ORG", "MNG"] as const;

export function canManagePaths(profileType?: string | null): boolean {
  return !!profileType && (PATH_MANAGE_PROFILES as readonly string[]).includes(profileType);
}
